import $ from "jquery";
window.$ = window.jQuery;
window.bootstrap = require("bootstrap");



function contentNav () {
	if ( $('section.content-nav').length ){
		let contNav = $('section.content-nav');
		let contNavHeight = $('section.content-nav').height();
		let navPosition = contNav.offset().top;
		let customOffset = 0;
		let paddadded = 0;
		
		function loadContentNav () {
			let headerHeight = $('header').height();
			let secPadding = 94;
			if ($(window).width() <= 1024) {headerHeight = 0; secPadding = 61;}
			if ($(window).scrollTop() >= contNav.offset().top - headerHeight) {
				$('html').css('scroll-margin-top', contNav.height() + headerHeight + secPadding + "px");
				contNav.addClass('fixed');
				if (paddadded == 0) {
					contNav.next().css("padding-top", parseInt(contNav.next().css("padding-top")) + contNavHeight);
				}
				paddadded = 1;
			}
			if ($(window).scrollTop() < contNav.next().offset().top - headerHeight) {
				$('html').css('scroll-margin-top', headerHeight + secPadding + "px");
				contNav.removeClass('fixed');
				
				if (paddadded == 1) {
					contNav.next().css("padding-top", parseInt(contNav.next().css("padding-top")) - contNavHeight);
				}
				paddadded = 0;
			}
			$('.navbar .nav-link').each(function(){
				if ($(this).hasClass('active')) {
					$(this).parent('li').addClass('active');
				}
				else {
					$(this).parent('li').removeClass('active');
				}
				let linkId = $(this).attr('href');
				if ( $(window).scrollTop() >= $(linkId).offset().top - $('header').height() - parseInt($('html').css('scroll-padding-top')) ) {
					$('.nav-link').not(this).removeClass('active');
					$(this).addClass('active');
				} 
			});
		}
		loadContentNav();
		$(window).on('scroll', () => {
			loadContentNav();
		});
		$('.content-nav .navbar .mobileOverlay').on('click', function(){
			if ($(window).width() <= 768) {
				$(this).closest('.navbar').toggleClass('clicked');
			}
		});
		$('a.nav-link').on('click',function(ev){
			let secId = $(this).attr('href');
			let headerHeight = $('header').height();
			if ($(window).width() <= 1024) {
				headerHeight = 0;
				$(this).closest('.navbar').toggleClass('clicked');
			}
			history.pushState({}, "", secId);
		});
		
	}
}
$(window).on('load', function(){
    contentNav();
});
$(function(){
	if ($('.service-teaser').length) {
		if ($(window).width() < 992){
			$('.service-teaser').on('click', function() {
				$(this).toggleClass('opened');
				$(this).find('ul').slideToggle(300);
				$(this).find('p').slideToggle(300);
			});
		}
	}
});

function magazinNav () {
	if ( $('.magazine-content-nav').length ){
		let magCont = $(".magazine-content");
		let magNav = $('.magazine-content-nav');
		let contPosition = $('.magazine-content').offset().top;
		let customOffset = 100;

		function loadMagazinNav () {
			
			let headerHeight = $('header').height();
			if ($(window).width() <= 1024) {headerHeight = 0; }
			if ($(window).scrollTop() >= contPosition - headerHeight) {
				magNav.addClass('fixed');
			}
			else {
				magNav.removeClass('fixed');
			}
			if ($(window).scrollTop() >= $('footer').offset().top - parseInt($('main').css('padding-bottom')) - parseInt(magNav.css('padding-bottom')) - headerHeight - magNav.height() ) {
				magNav.addClass('fixed-bottom');
			}
			else {
				magNav.removeClass('fixed-bottom');
			}
			
			$('#magazine-nav .nav-link').each(function(){
				if ($(this).hasClass('active')) {
					$(this).parent('li').addClass('active');
				}
				else {
					$(this).parent('li').removeClass('active');
				}
				let linkId = $(this).attr('href');
				if ( $(window).scrollTop() >= $(linkId).offset().top - $('header').height() - customOffset ) {
					$('.nav-link').not(this).removeClass('active');
					$(this).addClass('active');
				} 
			});
		}
		
		loadMagazinNav();
		$(window).on('scroll', () => {
			loadMagazinNav();
		});
		$('a.nav-link').on('click',function(ev){
			let secId = $(this).attr('href');
			if ($(window).width() <= 1024) {
				headerHeight = 0;
			}
			history.pushState({}, "", secId);
		});
	}
}
$(function(){
    magazinNav();
});

$(window).on('scroll', function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 1) {
        $(".header").addClass("stick");
    } else {
        $(".header").removeClass("stick");
    }
});

document.addEventListener("DOMContentLoaded", function(event) {
	let inputBox = document.querySelector('.search-container');
	
	if (document.querySelectorAll('.search-bar').length) {
		let searchIcon = document.querySelector('.search-bar');
		searchIcon.addEventListener('click', () => {
			inputBox.classList.add('open');
		});
	}
	
	if (document.querySelectorAll('.close-icon').length) {
		let closeIcon = document.querySelector('.close-icon');
		closeIcon.addEventListener('click', () => {
			inputBox.classList.remove('open');
		});
	}
});

$('.collapse').on('show.bs.collapse', function (e) {
    // hide the open one
	if ( $('.collapse.show').length ) {
    	$('.collapse.show').collapse('hide');
	}
})



$(function(){
	$('.grid .col')
		.each(function(){
			$(this).append('<div class="info"><div>' + $(this).text() + '</div></div>');
		})
		.on('click', function(e){
			e.stopPropagation();
			var ele = $(this);
    		if (!$('.grid .col').hasClass('selected')){
      		ele.addClass('selected');
    		} else
    		if ($('.grid .col').hasClass('selected')){
      		if (ele.hasClass('selected')){
        			ele.removeClass('selected');
      		} else {
        			$('.grid .col').removeClass('selected');
					setTimeout(function(){
					ele.addClass('selected');
				}, 500);
      	}
		}
	});

	$(document).on('click', function(){
		$('.grid .col').removeClass('selected');
	});
	
	setTimeout(function(){
		$('.grid .col:nth-child(2)').addClass('hovered');
		setTimeout(function(){
			$('.grid .col:nth-child(2)').removeClass('hovered').trigger('click');
		}, 654);
	}, 654);
});


$(document).ready(function() {
	$('.toast').delay(1000).slideDown(500);

	$( ".btn-close" ).on('click', function() {
	$	( ".toast" ).slideUp(500);
	});

	$('.toast-extarnel').delay(1000).slideDown(500);

	$( ".btn-close" ).on('click', function() {
	$	( ".toast-extarnel" ).slideUp(500);
	});
});




var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl)
})


// prevent browser from scrolling top while typing in searchfield




// Use addEventListener to attach the event handler
var e = document.getElementById('suggestionsearchscroller');
//we.addEventListener('keypress', myFunction);

function myFunction(event) {
  // Use event.key to get the pressed key
  e.value += event.key;

  // If you want to prevent the default behavior of the keypress event, you may use:
  // event.preventDefault();

  // Provide more context about the variable 'r' or remove it if not needed
  // r = ...; // <-- You need to define what 'r' is and what you want to do with it
}



import UoAccessability from "./modules/uo-accessibility/uo-accessibility";

document.addEventListener("DOMContentLoaded", function () {
	const uoAccessability = new UoAccessability({
		overwriteFocusVisibleStyles: true,
		hiddenClass: "visually-hidden", // BS >= 5: visually-hidden, BS < 5: sr-only
		helper: [
			{                
				helperName: {
					'de-de': "Hauptnavigation"
				},
				targetSelector: "header .hamburger",
				anchorID: "uo-target-nav",
				linkText: {
					'de-de': "Direkt zur Hauptnavigation"
				}
			},
			{
				helperName: {
					'de-de': "Inhalt"
				},
				targetSelector: "main",
				anchorID: "uo-target-content",
				linkText: {
					'de-de': "Direkt zum Inhalt"
				}
			},
			{
				helperName: {
					'de-de': "Footer"
				},
				targetSelector: "footer",
				anchorID: "uo-target-footer",
				linkText: {
					'de-de': "Direkt zum Footer"
				}
			},
		],
	});

});

//UO-Accessibility END